// obsidian-zitate.js — Verweise auf Vault-Notizen anklickbar machen.
//
// Antworten des Buddys nennen ihre Belege als `[pfad.md:zeile]`, „Quelle:
// datei.md" oder in Anfuehrungszeichen. Hier werden daraus Links, die die
// Notiz in der Vault oeffnen. Genutzt vom Chat (`script.js`) und von der
// schwebenden Antwortkachel an einer Markierung (`buddy-auswahl.js`) — das
// Modul fasst beim Laden nichts an, damit es auch in `node --test` importiert
// werden kann.

export function processObsidianCitations(element) {
    // Walk through all text nodes and find citation patterns
    const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    const nodesToProcess = [];
    let node;
    while (node = walker.nextNode()) {
        // Match any .md file reference
        if (/\.md/.test(node.textContent)) {
            nodesToProcess.push(node);
        }
    }

    // Process nodes in reverse order to avoid invalidating references
    nodesToProcess.reverse().forEach(textNode => {
        const text = textNode.textContent;
        // Match .md files in various formats:
        // 1. [file.md:line] - bracketed
        // 2. Any quoted path ending in .md (various quote styles)
        // 3. After keywords like Quelle/Notiz/Datei/aus
        const q = '"\u201c\u201d\u201e\u00ab\u00bb\u2018\u2019'; // Various quote chars
        const regex = new RegExp(
            '\\[([^\\]]+\\.md)(?::(\\d+))?\\]' +                      // [file.md:line]
            '|[' + q + ']([^' + q + '\\n]+\\.md)[' + q + ']' +        // "file.md"
            '|(?:Quelle|Notiz|Datei|aus)[:\\s]+[' + q + ']?([^\\n' + q + ']+?\\.md)[' + q + ']?(?=[\\s):\\]' + q + ']|$)',
            'gi'
        );

        // Split text by citations and create new nodes
        const parts = [];
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            // Groups: 1,2 = [file.md:line], 3 = "file.md", 4 = Quelle/Notiz/Datei: file.md
            const filePath = match[1] || match[3] || match[4];
            const lineNumber = match[2];

            if (!filePath) continue;

            let matchStart = match.index;
            let fullMatch = filePath; // Always just show the file path as link text

            // Find where the actual file path starts in the match
            const fullMatchText = match[0];
            const filePathIndex = fullMatchText.lastIndexOf(filePath);
            if (filePathIndex > 0) {
                matchStart = match.index + filePathIndex;
            }

            // Text before the citation
            if (matchStart > lastIndex) {
                parts.push({
                    type: 'text',
                    content: text.slice(lastIndex, matchStart)
                });
            }

            // The citation itself
            parts.push({
                type: 'citation',
                filePath: filePath,
                lineNumber: lineNumber,
                fullMatch: fullMatch
            });

            lastIndex = match.index + match[0].length;
        }

        // Remaining text after last citation
        if (lastIndex < text.length) {
            parts.push({
                type: 'text',
                content: text.slice(lastIndex)
            });
        }

        // Replace text node with new nodes
        if (parts.length > 0 && parts.some(p => p.type === 'citation')) {
            const fragment = document.createDocumentFragment();

            parts.forEach(part => {
                if (part.type === 'text') {
                    fragment.appendChild(document.createTextNode(part.content));
                } else {
                    // Create clickable link for citation
                    const link = document.createElement('a');
                    link.className = 'obsidian-citation-link';
                    link.href = '#';
                    link.title = `Öffnen: ${part.filePath}`;
                    link.textContent = part.fullMatch;

                    // Store file path for click handler
                    const filePath = part.filePath;

                    // Add click handler to open in vault panel (left of chat)
                    link.addEventListener('click', async (e) => {
                        e.preventDefault();
                        if (window.obsidianVault) {
                            // Aus dem Chat heraus rueckt die Vault daneben;
                            // aus der schwebenden Kachel (Chat zu) oeffnet sie
                            // allein — sonst ginge ungefragt der Chat auf.
                            const chatOffen = document
                                .getElementById('chat-interface')
                                ?.classList.contains('visible');
                            if (chatOffen) {
                                await window.obsidianVault.openWithChat();
                            } else if (!window.obsidianVault.panel?.classList.contains('visible')) {
                                await window.obsidianVault.open();
                            }
                            await window.obsidianVault.openFile(filePath);
                        }
                    });

                    fragment.appendChild(link);
                }
            });

            textNode.parentNode.replaceChild(fragment, textNode);
        }
    });
}

/// Die Quellenzeile („Quellen: …") kleiner setzen.
///
/// Markdown kann keine Klasse mitgeben; erkannt wird sie deshalb am Anfang
/// des letzten Absatzes.
export function quellenZeileMarkieren(element) {
    const absaetze = element?.querySelectorAll?.('p');
    if (!absaetze || absaetze.length === 0) return;
    const letzter = absaetze[absaetze.length - 1];
    if (letzter.textContent.trimStart().startsWith('Quellen:')) {
        letzter.classList.add('buddy-quellen');
    }
}
